(function (){
    'use strict';

    angular
        .module('services')
        .service('CurrencyService', CurrencyService);

    CurrencyService.$inject = ['$http', 'API_BASE'];

    function CurrencyService ($http, API_BASE) {
        var service = this;

        service.getCurrencies   = getCurrencies;
        service.getExchangeRate = getExchangeRate;

        function getCurrencies() {
            return $http.get(API_BASE + '/currencies/list',{headers : {'Content-Type' : 'application/json; charset=UTF-8'}});
        }

        function getExchangeRate(query) {
            return $http.get(API_BASE + '/currencies/conversion',{params: query});
        }
    }
})();